<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen overflow-x-auto">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">List of Users in the system</p>
      </div>
      <div class="flex justify-between">
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="p-2 bg-gray-200 w-52 m-2 mb-0 py-1 rounded-md"
        />
        <!-- search -->
        <button
          class="bg-primary mt-2 mx-2 text-white"
          @click="showCreateUser = true"
        >
          Create user
        </button>
      </div>
      <transition name="fade">
        <div
          v-if="loading"
          class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
        >
          <loader class="center-h-v" />
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="get_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ get_error }}
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="edit_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ edit_error }}
        </div>
      </transition>
      <transition name="fade">
        <div
          v-if="showSuccess"
          class="p-1 text-center text-sm w-full bg-green-200"
        >
          {{ edit_success }}
        </div>
      </transition>
      <div class="p-2">
        <!-- <ve-table :columns="columns" :table-data="tableData" /> -->

        <!-- <licence-tabs :updateLicenceList="updateLicenceList" v-if="searchInput"></licence-tabs> -->
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
          sort-order="asc"
        />

        <!-- <licence-tabs :updateLicenceList="updateLicenceList" v-if="!searchInput.length"></licence-tabs> -->
        <ve-table
          :columns="columns"
          :table-data="paginatedData"
          v-if="!searchInput.length"
          sort-order="asc"
        />

        <p v-if="tableData.length === 0" class="text-center py-3">
          No users yet
        </p>

        <p
          v-if="searchInput.length && filteredTableData.length === 0"
          class="text-center py-3"
        >
          No results
        </p>
        <list-paginator
          :current-page="currentPage"
          :total-pages="totalPages"
          @page-changed="onPageChanged"
        >
        </list-paginator>
      </div>
    </div>

    <create-user
      :users="users"
      :showCreateUser="showCreateUser"
      @close="close()"
      @handleSuccess="handleSuccess"
    ></create-user>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import ListPaginator from "../utils/listPaginator.vue";
import CreateUser from "./createUser.vue";
export default {
  name: "Users",
  components: {
    Loader,
    ListPaginator,
    CreateUser,
  },
  data() {
    return {
      showAddAnEvent: false,
      loading: false,
      get_error: null,
      edit_error: null,
      edit_success: null,
      showSuccess: false,
      showCreateUser: false,
      success_msg: null,
      searchInput: "",
      currentPage: 1,
      pageSize: 10,
      users: null,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "FullName",
          key: "a",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "UserName",
          key: "aa",
          title: "Username",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Email",
          key: "aaa",
          title: "Email",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "PhoneNumber",
          key: "aaaa",
          title: "Phone",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Organization",
          key: "b",
          title: "Organization",
          headerAlign: "left",
          align: "left",
        },

        {
          field: "Role",
          key: "x",
          title: "Role",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "PasswordChanged",
          key: "c",
          title: "Password Changed",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => {
            return row.PasswordChanged ? <p>Yes</p> : <p>No</p>;
          },
        },
        {
          field: "LastLogin",
          key: "xxx",
          title: "Last Login",
          headerAlign: "left",
          align: "left",
          // width: 200,
          renderBodyCell: ({ row }) => {
            const date = new Date(row.LastLogin);
            const options = {
              month: "numeric",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            };
            const formattedDate = date.toLocaleDateString("en-US", options);
            return formattedDate.split(",")[0] === "1/1/1" ? (
              ""
            ) : (
              <p className="whitespace-nowrap">
                {formattedDate.replace(",", "")}
              </p>
            );
          },
        },
        {
          field: "Action",
          key: "f",
          title: "Action",
          renderBodyCell: ({ row }) => {
            return row.Disabled ? (
              <button
                id={row.Id}
                class="bg-green-300 text-white hover:bg-green-500"
                onClick={(e) => this.handleEnablingUser(e, row.Id)}
              >
                Enable
              </button>
            ) : (
              <button
                id={row.Id}
                class="bg-red-300 text-white  hover:bg-red-500"
                onClick={(e) => this.handleDisablingUser(e, row.Id)}
              >
                Disable
              </button>
            );
          },
        },
      ],

      tableData: [
        {
          Name: "John Doe",
          Organization: "Veam",
          Location: "Westlands, Nairobi",
          Role: "HR Manager",
          DateCreated: "05 May 2022",
          Action: "Approved",
        },
        {
          Name: "John Doe",
          Organization: "Veam",
          Location: "Westlands, Nairobi",
          Role: "HR Manager",
          DateCreated: "05 May 2022",
          Action: "Approved",
        },
        {
          Name: "John Doe",
          Organization: "Veam",
          Location: "Westlands, Nairobi",
          Role: "HR Manager",
          DateCreated: "05 May 2022",
          Action: "Approved",
        },
      ],
    };
  },
  methods: {
    close() {
      this.showCreateUser = false;
    },
    handleSuccess(message) {
      this.showCreateUser = false;
      this.success_msg = message;
      this.showSuccess = true;
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
      this.getRequests();
    },
    onPageChanged(page) {
      this.currentPage = page;
    },
    handleClose() {
      this.showAddAnEvent = false;
      this.showCreateUser = false;
    },
    // /user/v1/request

    getUsers() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`user/${this.$ApiVersion}/request`, options).then(
        (response) => {
          if (response.data.StatusCode == 200) {
            this.loading = false;
            //console.log(response.data);
            this.tableData = response.data.Data;
            this.users = response.data.Data;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },
    handleEnablingUser(e, userId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const data = {
        userId,
        Disable: false,
      };
      axios.put(`user/${this.$ApiVersion}/disable`, data, options).then(
        (response) => {
          if (response.data.StatusCode == 200) {
            this.loading = false;
            this.edit_success = response.data.StatusMessage;
            this.getUsers();
            this.showSuccess = true;
            setTimeout(() => {
              this.showSuccess = false;
            }, 3000);
          } else {
            this.loading = false;
            this.edit_error = response.data.StatusMessage;
            setTimeout(() => {
              this.edit_error = null;
            }, 3000);
          }
        },
        (error) => {
          this.loading = false;
          this.edit_error = error.message;
          setTimeout(() => {
            this.edit_error = null;
          }, 3000);
        }
      );
    },
    handleDisablingUser(e, userId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const data = {
        userId,
        Disable: true,
      };
      axios.put(`user/${this.$ApiVersion}/disable`, data, options).then(
        (response) => {
          if (response.data.StatusCode == 200) {
            this.loading = false;
            this.edit_success = response.data.StatusMessage;
            this.getUsers();
            this.showSuccess = true;
            setTimeout(() => {
              this.showSuccess = false;
            }, 3000);
          } else {
            this.loading = false;
            this.edit_error = response.data.StatusMessage;
            setTimeout(() => {
              this.edit_error = null;
            }, 3000);
          }
        },
        (error) => {
          this.loading = false;
          this.edit_error = error.message;
          setTimeout(() => {
            this.edit_error = null;
          }, 3000);
        }
      );
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    totalPages() {
      return Math.ceil(this.tableData.length / this.pageSize);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.tableData.slice(startIndex, endIndex);
    },
  },
  created() {
    this.getUsers();
  },
};
</script>
